import { api } from '@shared/services/api';

export interface PlanLimits {
  minScheduleInterval: number;
  maxAgents: number;
  maxStorageGB: number;
  retentionDays: number;
}

export const limitsApi = {
  getPlanLimits: async (): Promise<PlanLimits> => {
    const response = await api.get('/plan-limits');
    return response.data;
  },
};
